<template>

    <div :id="setID"
         class="vw-100"
    >
        <div 
            class="background-image"
            :style="'background-image:url( ' + image + ' )'"
        >
        </div>
        <div class="container h-100">
            <div class="row h-100 justify-content-center">

                <div class="col-12 col-lg-8 mt-5">

                    <h3
                        class="copy text-center mb-3"
                        v-for="(copy, index) in content"
                        :key="index"
                    >
                        {{ copy }}
                    </h3>

                    <h4 class="sign-off text-center mt-5">{{ signoff }}</h4>

                </div>
                
            </div>
        </div>
    </div>

</template>

<script>

    // load assets
    import xmas_bg from "../../assets/xmas-bg.jpg";

     export default {
        name:"partners",

        data() {
            return {
                setID:"xmas-component",
                image: xmas_bg,
                content: [
                    "Our office will be taking a festive break from 20th December 2025, reopening on 5th January 2026.",
                    "During this time, Andrew is still available for any property enquiries or private viewings.",
                    "From all of us at Bellingen Property, we wish you a joyful holiday season, filled with warmth, laughter and time with those you hold dear.",
                ],
                signoff: "Andrew, Ingrid, Bianca & Elle"

            }
        }

    }

</script>

<style lang=scss >

    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";
    
    #xmas-component {
        align-items: center;
        display: flex;
        justify-content: center;
        min-height: 900px;
        position: relative;

        .background-image {
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            height: 100%;
            left:0;
            position: absolute;
            top:0;
            width: 100%;
            z-index: 0;
        }

        .copy {
            color: $white;
            font-family: $font-family-serif;
            font-weight: 700;
            letter-spacing: .5px;
            line-height: 1.75;
            position: relative;
        }

        .sign-off {
            color: $color_main;
            letter-spacing: .5px;
            line-height: 1.75;
            position: relative;
        }

    }

</style>